
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries/textile/products/textile-waste-reduction-and-recycling-software",
      function () {
        return require("private-next-pages/industries/textile/products/textile-waste-reduction-and-recycling-software.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries/textile/products/textile-waste-reduction-and-recycling-software"])
      });
    }
  